export default {
  completeProfile: {
    intro: {
      title: "Configurons votre compte",
      subtitle: "Quelques autorisations rapides nous aident à afficher des cotes plus pertinentes, à envoyer des mises à jour au bon moment et à améliorer votre expérience globale.",
    },
    tracking: {
      title: "Aidez Linemate à rester gratuit",
      subtitle: "Nous demandons votre autorisation pour suivre certaines activités sur cet appareil. En sélectionnant “Autoriser le suivi” à l'écran suivant, vous nous aiderez à :",
      buttonSubtext: "Vous pourrez modifier cette option plus tard dans l'application Réglages",
      cards: {
        support: {
          title: "Soutenir Linemate",
          body: "Cela nous aide à continuer d'améliorer l'app et les fonctionnalités que vous utilisez le plus.",
        },
        relevantContent: {
          title: "Voir du contenu plus pertinent",
          body: "Nous utilisons ces données pour afficher des offres, des tendances et des publicités plus pertinentes pour vous.",
        },
      },
    },
  },
};
